export class TestVariables {
    public cognitoUserPoolId: string;
    public cognitoUserPoolClientId: string;
    public restApiEndpoint: string;

    constructor() {
        this.cognitoUserPoolId = 'us-east-1_OUlJ3faMf';
        this.cognitoUserPoolClientId = 'a1u469s7dicql6tuo8141bu7c';
        this.restApiEndpoint = 'https://g22xu8k13b.execute-api.us-east-1.amazonaws.com/prod/';
    }
}

export default TestVariables;